// Compatibility shim for chroma-js export interop
// Ensures both the default export and namespace expose `scale` and other helpers
try {
  // Use require to avoid ESM import resolution oddities in some bundlers
  const chromaMod = require('chroma-js');
  const def = chromaMod && chromaMod.default ? chromaMod.default : chromaMod;

  if (chromaMod && def) {
    // If the default export exists but lacks helpers, copy them from the top-level
    if (chromaMod !== def) {
      Object.keys(chromaMod).forEach((k) => {
        if (k === 'default') return;
        if (def[k] === undefined && chromaMod[k] !== undefined) {
          def[k] = chromaMod[k];
        }
      });
      Object.keys(def).forEach((k) => {
        if (chromaMod[k] === undefined && def[k] !== undefined) {
          chromaMod[k] = def[k];
        }
      });
    }

    // expose on window for UMD modules that reference global.chroma
    if (typeof window !== 'undefined' && !window.chroma) {
      window.chroma = def;
    }
  }
} catch (e) {
  // If require isn't available or chroma-js is missing, fail silently — app can still run.
  // eslint-disable-next-line no-console
  console.warn('chroma-fix: could not normalize chroma-js exports', e && e.message);
}
